import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface BrandCampaignStepsState {
  search: string;
  start: number;
  length: number;
  sortColumn: string | null;
  sortOrder: "asc" | "desc" | null;
}

const initialState: BrandCampaignStepsState = {
  search: "",
  start: 1,
  length: 10,
  sortColumn: null,
  sortOrder: null,
};

const brandCampaignStepsSlice = createSlice({
  name: "brandCampaignSteps",
  initialState,
  reducers: {
    setSearch: (state, action: PayloadAction<string>) => {
      state.search = action.payload;
    },
    setStart: (state, action: PayloadAction<number>) => {
      state.start = action.payload;
    },
    setLength: (state, action: PayloadAction<number>) => {
      state.length = action.payload;
    },
    setSort: (
      state,
      action: PayloadAction<{
        column: string | null;
        order: "asc" | "desc" | null;
      }>
    ) => {
      state.sortColumn = action.payload.column;
      state.sortOrder = action.payload.order;
    },
    resetFilters: () => initialState,
  },
});

export const { setSearch, setStart, setLength, setSort, resetFilters } =
  brandCampaignStepsSlice.actions;

export default brandCampaignStepsSlice.reducer;
